import React, { useState } from "react"
import styles from "./PhoneNumberInput.module.scss"
import down from "../../assets/images/down_arrow.svg"
import Flag from "../../assets/images/flag.svg"
import UAE_Flag from "../../assets/images/uae_flag.svg"

export interface PhoneInputProps {
    value: string
    countryCode: string
    onChange: (data: { phone: string; countryCode: string }) => void
    name?: string
    placeholder?: string
    error?: boolean
    errorText?: string
    disabled?: boolean
}

const PhoneInput: React.FC<PhoneInputProps> = ({
    value,
    countryCode,
    onChange,
    name,
    placeholder = "Enter phone number",
    error,
    errorText,
    disabled,
}) => {
    const countries = [
        {
            name: "India",
            code: "+91",
            flag: Flag,
        },
        {
            name: "UAE",
            code: "+971",
            flag: UAE_Flag,
        },
    ]
    const [dropdownOpen, setDropdownOpen] = useState(false)

    const selectCountry = (code: string) => {
        onChange({ phone: value, countryCode: code })
        setDropdownOpen(false)
    }

    const onPhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const phone = e.target.value.replace(/\D/g, "")
        onChange({ phone, countryCode })
    }

    return (
        <div className={styles.container}>
            <div className={styles.wrapper}>
                <div className={styles.country_selector} onClick={() => !disabled && setDropdownOpen(!dropdownOpen)}>
                    <img src={countries.find(c => c.code === countryCode)?.flag} alt={countryCode} />
                    <img src={down} alt="down_arrow" style={{ width: 10, height: 10 }} />
                    {dropdownOpen && (
                        <div className={styles.dropdown}>
                            {countries.map(c => (
                                <div key={c.code} className={styles.option} onClick={() => selectCountry(c.code)}>
                                    <img src={c.flag} alt={c.code} />
                                    <span>
                                        {c.name} ({c.code})
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <input
                    type="tel"
                    name={name}
                    value={value}
                    placeholder={placeholder}
                    maxLength={10}
                    onChange={onPhoneChange}
                    disabled={disabled}
                    className={`${styles.phone_input} ${error ? styles.error_input : ""}`}
                />
            </div>
            {error && errorText !== undefined && <div className={styles.error_text}>{errorText}</div>}{" "}
        </div>
    )
}

export default PhoneInput
